import * as React from 'react';
import Layout from '../layout';
import { Catchline, ConfirmWrapper, ConfirmMessage, ConfirmTitle, ConfirmContent, Sep, ResumeVideo, ShareTitle, ShareList, ShareListItem } from './styled';
import { colors } from '../../variables';
import { Button, MobileMask } from '../../widgets/globaleStyledWidget';
import icoLinkedin from './images/ico-linkedin.svg';
import icoInsta from './images/ico-instagram.svg';
import icoWechat from './images/wechat.png';
import icoWeibo from './images/weibo.png';
import icoTalk from './images/talk.png';
import icoLine from './images/line.png';


import {FormattedMessage, injectIntl, useIntl} from 'react-intl';
import livstickApp from '../../models/livstick';

import videojs from 'video.js';
import manifest from '../../manifest';

const videoJsOptions = {
  controls: true,
  bigPlayButton: true,
  fluid: true,
};


const EndPage:React.FunctionComponent = () => {

  const videoEl = React.useRef(null);

  const intl = useIntl();

  const [res, setRes] = React.useState<any>({});

  const start = async () => {
    const _res = await livstickApp.pullNoLog();
    
    setRes(_res);

    console.log('ref', videoEl)
    var _player = videojs(videoEl.current, videoJsOptions, () => {
      const version_info = 'Using video.js ' + videojs.VERSION;
      videojs.log(version_info);
      _player.src({ src: _res.media_url });
      _player.load();
      //_player.play();
    });

  }

  React.useEffect(() => {
    start();
  }, [])
    return <Layout>
      <ConfirmWrapper>
        <ConfirmContent>
        
          {res.type == "LIVSTICK_P" && <img src={`https://fm2x.me/liv3/${res.media_url}`} width="100%" />}
          {res.type == "LIVSTICK_V" && <ResumeVideo>
            <video id="myVideo" ref={videoEl} className="video-js vjs-default-skin" playsInline></video>
          </ResumeVideo>}
          {manifest.VM && <p>https://mm2.fr/liv4/vm.html#/{livstickApp.code}</p>}
          <ConfirmTitle dangerouslySetInnerHTML={{__html: intl.formatMessage({id: "form_txt_success_title"})}}></ConfirmTitle>
          {/* {livstickApp.planification && <>Votre message sera envoyé le {moment()}</>} */}
          {/* <FormattedMessage id="form_txt_sent" defaultMessage="Votre message sera envoyé le ..."/> */}
          <ConfirmMessage><FormattedMessage id="form_txt_success"/></ConfirmMessage>
          {/*<Button color={colors.main} hover="main"><FormattedMessage id="form_txt_button_edit"/></Button>*/}
          {/* ROMAIN : Ajout pour HO */}
          <Sep/>
          <ShareTitle dangerouslySetInnerHTML={{__html: intl.formatMessage({id: "share_txt_share"})}}></ShareTitle>
          <ShareList>
            <ShareListItem color={colors.instagram}><a href={intl.formatMessage({id:'share_txt_instagram'})} target="_blank"><img src={icoInsta} /></a></ShareListItem>
            <ShareListItem color={colors.instagram}><a href={intl.formatMessage({id:'share_txt_linkedin'})} target="_blank"><img src={icoLinkedin} /></a></ShareListItem>
            <ShareListItem color={colors.instagram}><a href={intl.formatMessage({id:'share_txt_wechat'})} target="_blank"><img src={icoWechat} /></a></ShareListItem>
            <ShareListItem color={colors.instagram}><a href={intl.formatMessage({id:'share_txt_weibo'})} target="_blank"><img src={icoWeibo} /></a></ShareListItem>
            <ShareListItem color={colors.instagram}><a href={intl.formatMessage({id:'share_txt_talk'})} target="_blank"><img src={icoTalk} /></a></ShareListItem>
            <ShareListItem color={colors.instagram}><a href={intl.formatMessage({id:'share_txt_line'})} target="_blank"><img src={icoLine} /></a></ShareListItem>
          </ShareList>
          
        </ConfirmContent>
      </ConfirmWrapper>

    </Layout>;
}

export default injectIntl(EndPage);